import { render } from "./DocumentsBlock.vue?vue&type=template&id=5b857d5f"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__